import { CreateArticleRRS, CreateLocalBusinessRRS, CreateProductRRS } from './RrsService.js';

interface RrsHandlerProps {
  type: 'product' | 'localBusiness' | 'article' | (string & {}); // string could be removed to make it more strict
  name?: string;
  headline?: string;
  price?: string;
  image?: string;
  url: string;
  description?: string;
  datePublished?: string;
  dateModified?: string;
}

const RrsHandler = ({
  type,
  name,
  headline,
  price,
  image,
  url,
  description,
  datePublished,
  dateModified,
}: RrsHandlerProps) => {
  const createRRS = () => {
    switch (type) {
      case 'localBusiness':
        return CreateLocalBusinessRRS({ name, image, url, description });
      case 'product':
        return CreateProductRRS({ name, price, image, url, description });
      case 'article':
        return CreateArticleRRS({
          headline,
          image,
          url,
          description,
          datePublished,
          dateModified,
        });
      default:
        return null;
    }
  };

  return <script type="application/ld+json">{createRRS()}</script>;
};

export default RrsHandler;
